var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"layoutRef",staticClass:"layout",class:_vm.typeClass},[_c('TheHeader',{staticClass:"layout__header"}),_c('div',{staticClass:"layout__content"},[_vm._t("default")],2),_c('TheFooter',{staticClass:"layout__footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }